export const loadedArticlesByRecommId: { [key: string]: number } = {};
export const maxLoadedArticles = 30 as number;
